<template>
    <div class="content-wrapper">
        <!-- Content Header (Page header) -->
        <div class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h1 class="m-0 text-dark">Delivery Instruction List</h1>
                    </div><!-- /.col -->
                    <div class="col-sm-6">
                        <button class="btn btn-info float-right" @click="showCreateModal"><i class="fas fa-plus-circle"></i> Add New</button>
                    </div><!-- /.col -->
                </div><!-- /.row -->
            </div><!-- /.container-fluid -->
        </div>
        <!-- /.content-header -->
        <!-- Main content -->
        <section class="content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-header">
                                <form v-on:keyup.enter="searchData">
                                    <div class="row">
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label for="merchant_id">Merchant</label>
                                                <v-select name="merchant_id"
                                                    v-model="search.merchant_id"
                                                    label="text"
                                                    :reduce="item => item.id"
                                                    :options= commonObj.merchantList
                                                    :placeholder="$t('globalTrans.select')"
                                                />
                                            </div>
                                        </div>  
                                        <div class="col-md-3">
                                            <div class="form-group" style="margin-top:28px;">
                                                <button class="btn btn-info btn-sm mr-2" type="submit" @click.prevent="searchData"><i class="fa fa-search"></i></button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div class="card-body mr-20">
                                <b-overlay :show="loader">
                                    <div class="table-responsive">
                                        <div style="width:100%; overflow-x:auto;">
                                            <table class="table table-bordered table-striped table-sm text-center">
                                                <thead>
                                                    <tr>
                                                        <th>SL </th>
                                                        <th>Merchant </th>
                                                        <th>Title</th>
                                                        <th>Created By</th>
                                                        <th>Updated By</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </thead>
                                                <tfoot>
                                                    <tr>
                                                        <th>SL </th>
                                                        <th>Merchant </th>
                                                        <th>Title</th>
                                                        <th>Created By</th>
                                                        <th>Updated By</th>
                                                        <th>Action</th>
                                                    </tr>
                                                </tfoot>
                                                <tbody>
                                                    <tr v-for="(item, key) in listData" :key="key">
                                                        <td>{{ key+1 }}</td>
                                                        <td>{{ item.merchant ? item.merchant.business : '' }}</td>
                                                        <td>{{ item.title }}</td>
                                                        <td>{{ item.createdBy ? item.createdBy.name : '' }}</td>
                                                        <td>{{ item.updatedBy ? item.updatedBy.name : '' }}</td>
                                                        <td style="text-align:center;">                                    
                                                            <button class="btn btn-warning btn-sm mr-1" @click="editInstruction(hub)"><i class="fas fa-pencil-alt"></i></button>
                                                            <button class="btn btn-danger btn-sm"  @click="deleteInstruction(index, hub.id)"><i class="fas fa-trash"></i></button>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div class="mt-3">
                                        <b-pagination
                                            v-model="pagination.currentPage"
                                            :per-page="pagination.perPage"
                                            :total-rows="pagination.totalRows"
                                            @input="searchData"
                                        />
                                    </div>
                                </b-overlay>
                            </div>
                        </div>
                    </div>
                </div>
            </div><!-- /.container-fluid -->
        </section>
        <div v-if="createModal" class="modal fade show" style="display:block" tabindex="-1" id="addHubModal" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <b-overlay :show="loader">
                        <div class="modal-header bg-info text-white">
                            <h5 class="modal-title text-center w-100">Create Delivery Instruction</h5>
                            <button type="button" class="close" aria-label="Close" @click="cancelModal">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                                <form @submit.prevent="handleSubmit(createArea)">
                                    <div class="row">
                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <ValidationProvider name="Merchant" vid="merchant_id" v-slot="{errors}" rules="required|min_value:1">
                                                <div class="form-group">
                                                    <label for="merchant_id">Merchant <span class="text-danger" title="Required">*</span></label>
                                                    <v-select name="merchant_id"
                                                        v-model="form.merchant_id"
                                                        label="text"
                                                        :reduce="item => item.id"
                                                        :options= commonObj.merchantList
                                                        :placeholder="$t('globalTrans.select')"
                                                    />
                                                    <span class="text-danger">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <ValidationProvider name="Title" vid="title" v-slot="{errors}" rules="required">
                                                <div class="form-group">
                                                    <label for="title">Title <span class="text-danger" title="Required">*</span></label>
                                                    <textarea d="title" v-model="form.title" class="form-control" placeholder="Enter Title"> </textarea>
                                                    <span class="text-danger">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                </form>
                            </ValidationObserver>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-info" @click.prevent="createArea">Save</button>
                            <button type="button" class="btn btn-danger" @click="cancelModal">Cancel</button>
                        </div>
                    </b-overlay>
                </div>
            </div>
        </div>
        <div v-if="editModal" class="modal fade show" style="display:block" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <b-overlay :show="loader">
                        <div class="modal-header bg-info text-white">
                            <h5 class="modal-title text-center w-100">Edit Delivery Instruction</h5>
                            <button type="button" class="close" aria-label="Close" @click="cancelModal">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <ValidationObserver ref="editForm" v-slot="{ handleSubmit }">
                                <form @submit.prevent="handleSubmit(updateInstruction)">
                                    <!-- <input type="hidden" v-model="form_edit.id" /> -->
                                    <div class="row">
                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <ValidationProvider name="Merchant" vid="merchant_id" v-slot="{errors}" rules="required|min_value:1">
                                                <div class="form-group">
                                                    <label for="merchant_id">Merchant <span class="text-danger" title="Required">*</span></label>
                                                    <v-select name="merchant_id"
                                                        v-model="form_edit.merchant_id"
                                                        label="text"
                                                        :reduce="item => item.id"
                                                        :options= commonObj.merchantList
                                                        :placeholder="$t('globalTrans.select')"
                                                    />
                                                    <span class="text-danger">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <ValidationProvider name="Title" vid="title" v-slot="{errors}" rules="required">
                                                <div class="form-group">
                                                    <label for="title">Title <span class="text-danger" title="Required">*</span></label>
                                                    <textarea d="title" v-model="form_edit.title" class="form-control" placeholder="Enter Title"> </textarea>
                                                    <span class="text-danger">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                </form>
                            </ValidationObserver>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-info" @click.prevent="updateInstruction">Update</button>
                            <button type="button" class="btn btn-danger" @click="cancelModal">Cancel</button>
                        </div>
                    </b-overlay>
                </div>
            </div>
        </div>
        <div v-if="deleteModal" class="modal fade show" style="display:block" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-default" role="document">
                <div class="modal-content">
                    <b-overlay :show="loader">
                        <div class="modal-header bg-info text-white">
                        <h5 class="modal-title text-center w-100">Delete Confirmation</h5>
                        </div>
                        <div class="modal-body">
                            <input type="hidden" name="del_id" />
                            <h3 class="text-center">Are you sure to delete ?</h3>
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-info" @click="destroyInstruction">Delete</button>
                            <button type="button" class="btn btn-danger" @click="cancelModal">Cancel</button>
                        </div>
                    </b-overlay>
                </div>
            </div>
        </div>    
    </div>
</template>
<script>
    import config from '@/config'
    export default {
        name:'DeliveryInstruction',
        data () {
            return { 
                loader: false,   
                search: {
                    title: '',
                    merchant_id: '',
                },
                form:{
                    merchant_id: '',
                    title: '',
                },
                form_edit:'',
                errors:[],
                createModal:false,
                editModal:false,
                deleteModal:false,
                pagination: {
                    currentPage: 1,
                    totalRows: 0,
                    perPage: this.$store.state.commonObj.perPage,
                    slOffset: 1
                }
            }
        },
        created () {
            this.loadData()
        },
        computed : {
            authUser () {
                return this.$store.state.authUser
            },
            stateReload () {
                return this.$store.state.stateReload
            },
            listData () {
                return this.$store.state.list
            },
            commonObj () {
                return this.$store.state.commonObj
            }
        },
        methods:{
            searchData () {
                this.loadData()
            },
            async loadData(){       
                this.loader = true 
                const params = Object.assign({}, this.search, { page: this.pagination.currentPage, per_page: this.pagination.perPage })       
                const response = await config.getData('/merchant-delivery-instruction', params)
                this.loader = false
                if (response.success) {
                    this.$store.dispatch('setList', response.data.data)
                    this.paginationData(response.data)
                } else {
                    this.$store.dispatch('setList', [])
                }
            },
            paginationData (data) {
                this.pagination.currentPage = data.current_page
                this.pagination.totalRows = data.total
                this.pagination.perPage = data.per_page
                this.pagination.slOffset = this.pagination.perPage * this.pagination.currentPage - this.pagination.perPage + 1
            },
            showCreateModal(){
                this.createModal = true;
            },
            async createArea(){
                this.loader = true
                const response = await config.postData('/merchant-delivery-instruction/store', this.form)
                this.loader = false
                if (response.success) {
                    this.createModal = false;
                    this.form.merchant_id = this.form.title = ''          
                    this.$toast.success({
                        title: 'Success',
                        message: 'Delivery Instruction created successfully',
                        color: '#218838'
                    }) 
                } else {
                    this.$refs.form.setErrors(response.errors)
                    this.$toast.error({
                        title: 'Error',
                        message: 'Sorry, something went wrong',
                        color: '#dc3545'
                    })   
                }
            },
            cancelModal(){
                this.createModal = false;
                this.editModal = false;
                this.deleteModal = false;
                this.form.title = this.form.merchant_id = ''
            },
            editInstruction(area){
                this.editModal = true;
                this.form_edit = area;
            },
            async updateInstruction(){
                this.loader = true
                const response = await config.postData('/merchant-delivery-instruction/update', this.form_edit)
                this.loader = false
                if (response.success) {
                    this.editModal = false;            
                    this.$toast.success({
                        title: 'Success',
                        message: 'Delivery Instruction updated successfully',
                        color: '#218838'
                    })  
                } else {
                    this.$refs.editForm.setErrors(response.errors)
                    this.$toast.error({
                        title: 'Error',
                        message: 'Sorry, something went wrong',                    
                        color: '#dc3545'
                    })  
                }
            },
            deleteInstruction(key, area_id){
                this.area_id = area_id;
                this.key = key;
                this.deleteModal = true;
            },
            async destroyInstruction(){
                this.loader = true
                const response = await config.deleteData('/merchant-delivery-instruction/destroy/'+this.area_id)
                this.loader = false           
                this.deleteModal = false
                if(response.success) {
                    this.loadData()
                    this.$toast.success({
                        title: 'Success',
                        message: response.message,
                        color: '#218838'
                    }) 
                } else {
                    this.$toast.error({
                        title: 'Error',
                        message: response.message,
                        color: '#dc3545'
                    })
                }
            },
        }
    }
</script>
<style>
    .w-35{
        width:35px;
    }
</style>